import React, { useState } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import { TextField } from '@material-ui/core';

interface EntryType {
  title: string;
}

export const NamespaceInput = (props: {
  onChange: (clusterGroup?: string) => void;
  product?: string;
  team?: string;
  provider?: string;
  clusterGroup?: string;
  label?: string;
  helperText?: string;
  required?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  id?: string;
  value?: string;
  freeSolo?: boolean;
}) => {
  const catalogApi = useApi(catalogApiRef);
  const [entries, setEntries] = useState<EntryType[]>([]);
  const [initialValue, setInitialValue] = useState<EntryType | string>('');
  const { loading } = useAsync(async () => {
    if (props.product && props.team && props.clusterGroup) {
      const entity = await catalogApi.getEntityByRef(
        `product:${props.product}`,
      );
      if (entity) {
        const items = Array.from(
          new Set(
            (entity.spec?.data as any).clusters
              ?.filter((it: any) => it.provider === props.provider)
              .filter((it: any) => it.group === props.clusterGroup)
              .map(({ namespaces }: any) => namespaces)
              .flat()
              .sort(),
          ),
        ).map((it: any) => {
          return { title: it };
        });
        let initialEntry = items.find(e => e.title === props.value);
        if (!initialEntry && props.value) {
          props.onChange(undefined);
        } else if (!initialEntry && items.length == 1) {
          initialEntry = items[0];
          props.onChange(items[0].title);
        } else if (items.length == 0) {
          props.onChange(undefined);
        }
        setEntries(items);
        setInitialValue(initialEntry || '');
      } else {
        setEntries([]);
        setInitialValue('');
        props.onChange(undefined);
      }
    } else {
      setEntries([]);
      setInitialValue('');
      props.onChange(undefined);
    }
  }, [props.product, props.value, props.team, props.clusterGroup]);

  const defaultProps = {
    options: entries,
    getOptionLabel: (option: EntryType) => (option?.title ? option.title : ''),
  };

  return (
    <FormControl
      margin="dense"
      required={props.required}
      fullWidth={props.fullWidth}
    >
      <Autocomplete
        {...defaultProps}
        id={props.id}
        value={initialValue}
        loading={loading}
        freeSolo={props.freeSolo}
        noOptionsText={
          'No namespaces available for the selected configuration, please create a new namespace via the portal.'
        }
        renderInput={params => (
          <TextField
            {...params}
            label={'Namespace'}
            margin="dense"
            FormHelperTextProps={{ margin: 'dense', style: { marginLeft: 0 } }}
            variant="outlined"
            required={props.required}
            InputProps={params.InputProps}
            error={props.error}
          />
        )}
        onChange={(_, newValue) =>
          props.onChange((newValue as EntryType)?.title)
        }
      />
    </FormControl>
  );
};
